/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { DragDropContext, Droppable } from '@insticator/insticator-ui';
import Answer from 'material/embeds/content/shared/answer/answer_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/answerset/answerset_styles';



/* ========== ~~~~~~~~~~ EMBED : ANSWER SET ~~~~~~~~~~ ========== */
const AnswerSet = (props) => {
    //this function is a helper that tells the dnd library if our answers are displayed vertical or horizonatally
    const draggableDirection = () => {
        switch (props.currentContentStatus.questionBased.type) {
            case 'image1':
            case 'image2':
            case 'emoji':
                return 'horizontal';
            default:
                return 'vertical';
        }
    };
    // this function is used to sort answers and format array to work with DragAndDrop
    const sortAnswers = () => {
        let options = [];
        Object.keys(props.currentContentStatus.questionBased.options).forEach((option, index) =>  {
            options.push({
                id: option,
                position: props.currentContentStatus.questionBased.options[option].position,
                element: <Answer key={option} contentId={props.contentId} optionId={option} type={props.currentContentStatus.questionBased.type} isEditable={props.isEditable} />})
        });
        return options.sort((a,b) => a.position - b.position);
    };
    //this function will render a draggable context with draggable answers as children
    const renderDraggableContext = () => (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable
                klass={`answerset ${props.classes.answerset} ${props.location} answeramount-${props.numberOfOptions} ${props.currentContentStatus.questionBased.type} answeramount-${props.numberOfOptions} answerset-${props.currentContentStatus.questionBased.type}`}
                droppableId={'droppable1'}
                direction={draggableDirection()}
                elements={sortAnswers()}
            />
        </DragDropContext>
    );
    //this function will render a non draggable read only version of the answers in their sorted order
    const renderNonEditableAnswers = () => (
        <div className={`answerset ${props.classes.answerset} answeramount-${props.numberOfOptions} isDraggingOver-false ${props.currentContentStatus.questionBased.type}`}>
            { sortAnswers().map(answer => answer.element)}
        </div>
    );
    //this funciton will reorder our answers on drag drop and fire an action to update redux
    const onDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination || source.index === destination.index) { return; } // dropped outside the list
        let options = JSON.parse(JSON.stringify(props.currentContentStatus.questionBased.options));
        let selected = result.draggableId;
        Object.keys(options).forEach(answer => {
            if(source.index < destination.index){
                if(options[answer].position <= destination.index && options[answer].position > source.index) options[answer].position --;
            } else {
                if(options[answer].position >= destination.index && options[answer].position < source.index) options[answer].position ++;
            }
        });
        options[selected].position = destination.index;
        props.sortOptions(props.contentId, options)
    };

    const areWeSorting = () => props.isEditable;
    //this will return the madness above
    return areWeSorting() ? renderDraggableContext() : renderNonEditableAnswers()
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AnswerSet);
